import React, {useCallback, useMemo, useState} from 'react';
import parse from 'html-react-parser';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';
import Heading from 'js/components/Common/Heading/Heading';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import Container from 'js/components/Common/Container/Container';
import AttachedVideo from 'js/components/Common/AttachedVideo/AttachedVideo';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './Overview.module.pcss';



export type PageType = 'Product' | 'SubjectMatter' | 'SelfLearning';
interface Props {
    pageId: number,
    pageType: PageType
}
const Overview = ({pageId, pageType}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [pageTitle, setPageTitle] = useState<string>('');
    const [info, setInfo] = useState<string>('');
    const [attachedVideoData, setAttachedVideoData] = useState<{videoLink: string, videoPreview: any}>(null);
    const { isLoading, error } = useFetchData({
        query: `${fetchData(pageId, pageType)}`,
        condition: !!pageId,
        updateData: (data:any) => {
            if (pageType === 'SelfLearning') {
                setTitle(data?.post?.SelfLearning?.titleOverview);
                setInfo(data?.post?.SelfLearning?.descriptionOverview);
                return;
            }
            setPageTitle(data?.productLegacy?.name);
            setAttachedVideoData(data?.productLegacy?.ProductLegacyFields?.attachedVideo);
            setInfo(data?.productLegacy?.ProductLegacyFields?.overviewDescription);
            if (pageType === 'Product') {
                setTitle(data?.product?.ProductGlobal?.overviewTitleProduct);
            } else {
                setTitle(data?.subjectMatter?.SubjectMatterGlobal?.overviewTitleSm);
            }
        }
    });

    const eventCategory = useMemo(() => {
        switch (pageType) {
            case 'Product': return 'Product page';
            case 'SubjectMatter': return 'Subject Mater page';
            case 'SelfLearning': return 'Self Learning page';
            default : return '';
        }
    }, [pageType]);

    const sendMixPanelPlayEvent = useCallback( async () => {
        await MixPanelWrapper.TrackEvent(
            'Play Video',
            {
                category: eventCategory,
                value: `${pageTitle}`
            });
    }, [eventCategory, pageTitle]);

    return (
        <DataValidator data={!!info && !!title && !isLoading && !error}>
            <section className={`${classes.Overview} ${pageType === 'SelfLearning' ? classes.SelfLearningOverview : ''} ${!attachedVideoData?.videoLink?.length ? classes.WithoutVideo : ''}`}>
                <Container additionalClass={classes.Wrap}>
                    <AttachedVideo
                        title={pageTitle}
                        customVideoSize={
                            {
                                width: '700',
                                height: '392'
                            }
                        }
                        sendEventHandler={async () => await sendMixPanelPlayEvent()}
                        link={attachedVideoData?.videoLink}
                        withoutInfo={true}
                        preview={attachedVideoData?.videoPreview} />
                    <div className={classes.Info}>
                        <Heading text={title} type={'h2'} />
                        <div>
                            {parse(info || '', { trim: true })}
                        </div>
                    </div>
                </Container>
            </section>
        </DataValidator>
    );
};

export default Overview;
